export const smartguideDefaultValue = [
  {
    id: 'L1',
    type: 'question',
    text: 'Hi, what can I help you with today?',
    answers: [
      {
        id: 'L1.0',
        text: 'I want to make changes to my indoor temperature.',
      },
      {
        id: 'L1.1',
        text: 'I want to boost my hot water production.',
      },
      {
        id: 'L1.2',
        text: 'I want to boost my ventilation.',
      },
    ],
  },
  {
    id: 'L1.0',
    type: 'question',
    text: 'What do you want to change?',
    answers: [
      {
        id: 'L2.0.0',
        text: 'I want to increase my indoor temperature.',
      },
      {
        id: 'L2.0.1',
        text: 'I want to decrease my indoor temperature.',
      },
      {
        id: 'L2.0.2',
        text: 'I want to turn on heating.',
      },
      {
        id: 'L2.0.3',
        text: 'I want to turn off heating.',
      },
      {
        id: 'L2.0.4',
        text: 'I want to turn on cooling.',
      },
      {
        id: 'L2.0.5',
        text: 'I want to turn off cooling.',
      },
    ],
  },
  {
    id: 'L1.1',
    type: 'statement',
    text: 'We have now started boosting your hot water production. It will automatically go back to its default state after the increase is done.',
  },
  {
    id: 'L1.2',
    type: 'statement',
    text: 'We have now boosted the ventilation. It will automatically go back to its default state in 4 hours.',
  },
  {
    id: 'L2.0.0',
    type: 'question',
    text: 'Which room do you want to increase?',
    answers: [
      {
        id: 'L3.0.0',
        text: 'Living room',
      },
      {
        id: 'L3.0.1',
        text: 'Kitchen',
      },
      {
        id: 'L3.0.2',
        text: 'Bedroom No. 1',
      },
      {
        id: 'L3.0.3',
        text: 'Bedroom No. 2',
      },
      {
        id: 'L3.0.4',
        text: 'Basement',
      },
    ],
  },
  {
    id: 'L2.0.1',
    type: 'question',
    text: 'Which room do you want to decrease?',
    answers: [
      {
        id: 'L3.1.0',
        text: 'Living room',
      },
      {
        id: 'L3.1.1',
        text: 'Kitchen',
      },
      {
        id: 'L3.1.2',
        text: 'Bedroom No. 1',
      },
      {
        id: 'L3.1.3',
        text: 'Bedroom No. 2',
      },
      {
        id: 'L3.1.4',
        text: 'Basement',
      },
    ],
  },
  {
    id: 'L2.0.2',
    type: 'statement',
    text: 'We have now turned on heating in your system.',
  },
  {
    id: 'L2.0.3',
    type: 'statement',
    text: 'We have now turned off heating in your system.',
  },
  {
    id: 'L2.0.4',
    type: 'statement',
    text: 'We have now turned on cooling in your system.',
  },
  {
    id: 'L2.0.5',
    type: 'statement',
    text: 'We have now turned off cooling in your system.',
  },
  {
    id: 'L3.0.0',
    type: 'question',
    text: 'You have a schedule active in the product which prevents changing the temperature. Do you want to want to turn off the scheduling',
    answers: [
      {
        id: 'L4.0.0',
        text: 'Yes',
      },
    ],
    cancelBtnText: 'No',
    isReplaced: 'true',
  },
  {
    id: 'L3.0.1',
    type: 'question',
    text: 'You have a schedule active in the product which prevents changing the temperature. Do you want to want to turn off the scheduling',
    answers: [
      {
        id: 'L4.0.1',
        text: 'Yes',
      },
    ],
    cancelBtnText: 'No',
    isReplaced: 'true',
  },
  {
    id: 'L3.0.2',
    type: 'statement',
    text: 'We have now increased the set temperature for bedroom 1. Due to the slowness of heating a house it might take upto 24 hours to notice the increase.',
  },
  {
    id: 'L3.0.3',
    type: 'statement',
    text: 'We have now increased the set temperature for bedroom 2. Due to the slowness of heating a house it might take upto 24 hours to notice the increase.',
  },
  {
    id: 'L3.0.4',
    type: 'statement',
    text: 'We have now increased the set temperature for basement. Due to the slowness of heating a house it might take upto 24 hours to notice the increase.',
  },
  {
    id: 'L3.1.0',
    type: 'question',
    text: 'You have a schedule active in the product which prevents changing the temperature. Do you want to want to turn off the scheduling',
    answers: [
      {
        id: 'L4.1.0',
        text: 'Yes',
      },
    ],
    cancelBtnText: 'No',
    isReplaced: 'true',
  },
  {
    id: 'L3.1.1',
    type: 'question',
    text: 'You have a schedule active in the product which prevents changing the temperature. Do you want to want to turn off the scheduling',
    answers: [
      {
        id: 'L4.1.1',
        text: 'Yes',
      },
    ],
    cancelBtnText: 'No',
    isReplaced: 'true',
  },
  {
    id: 'L3.1.2',
    type: 'statement',
    text: 'We have now decreased the set temperature for bedroom 1. Due to the slowness of heating a house it might take upto 24 hours to notice the decrease.',
  },
  {
    id: 'L3.1.3',
    type: 'statement',
    text: 'We have now decreased the set temperature for bedroom 2. Due to the slowness of heating a house it might take upto 24 hours to notice the decrease.',
  },
  {
    id: 'L3.1.4',
    type: 'statement',
    text: 'We have now decreased the set temperature for basement. Due to the slowness of heating a house it might take upto 24 hours to notice the decrease.',
  },
  {
    id: 'L4.0.0',
    type: 'statement',
    text: 'We have now increased the set temperature for living room. Due to the slowness of heating a house it might take upto 24 hours to notice the decrease.',
  },
  {
    id: 'L4.0.1',
    type: 'statement',
    text: 'We have now increased the set temperature for kitchen. Due to the slowness of heating a house it might take upto 24 hours to notice the increase.',
  },
  {
    id: 'L4.1.0',
    type: 'statement',
    text: 'We have now decreased the set temperature for living room. Due to the slowness of heating a house it might take upto 24 hours to notice the decrease.',
  },
  {
    id: 'L4.1.1',
    type: 'statement',
    text: 'We have now decreased the set temperature for kitchen. Due to the slowness of heating a house it might take upto 24 hours to notice the increase.',
  },
];

export const get = () => {
  const smartguide = smartguideDefaultValue;

  return new Promise(resolve => {
    const response = {
      status: 200,
      data: smartguide,
    };

    resolve(response);
  });
};
